import axios from 'axios'

export default class Geocoder {
  constructor({ apiKey, rootUrl }) {
    this.apiKey = apiKey
    this.rootUrl = rootUrl || 'https://maps.googleapis.com/maps/api/geocode/json'
  }

  async fetchGeolocationFromAddress(address) {
    const stringAddress = this.toAddressString(address)
    const params = { address: stringAddress, key: this.apiKey }
    return await axios.get(this.rootUrl, { params })
  }

  toAddressString(address) {
    const keys = [
      'address_line_1',
      'address_line_2',
      'city',
      'province',
      'state',
      'postal_code',
      'zip_code',
      'country',
    ]
    return keys
      .map(k => address[k])
      .filter(l => !!l)
      .join(', ')
  }
}
